import { useTranslation } from 'react-i18next';
import React from 'react';
import BoldVerticalBarChart, {
	BoldVerticalBarChartProps,
} from '@components/report/chart/bold-vertical-bar-chart/BoldVerticalBarChart';
import VerticalBarAverageChart, {
	VerticalBarAverageChartProps,
} from '@components/report/chart/vertical-bar-average-chart/VerticalBarAverageChart';
import ReportCard from '@components/report/report-card/ReportCard';
import { threeDivisionGridClass } from '@components/report/style.css';

export interface EngagementTtProps {
	averageViews?: VerticalBarAverageChartProps;
	averageLikes?: VerticalBarAverageChartProps;
	averageComments?: VerticalBarAverageChartProps;
	averageShares?: VerticalBarAverageChartProps;
	averageSaves?: VerticalBarAverageChartProps;
	engagementRate?: BoldVerticalBarChartProps;
	isLoading?: boolean;
	isError?: boolean;
	lackOfPermission?: boolean;
}

const EngagementTt = ({
	averageViews,
	averageLikes,
	averageComments,
	engagementRate,
	averageShares,
	averageSaves,
	isLoading,
	isError,
	lackOfPermission,
}: EngagementTtProps) => {
	const { t } = useTranslation('infReportTiktok');
	const status = { isLoading, isError, lackOfPermission };
	return (
		<div className={threeDivisionGridClass}>
			<ReportCard
				label={t('features.report.section-content.tt.engagement-tt.average-views.label')}
				tooltip={t(
					'features.report.section-content.tt.engagement-tt.average-views.tooltip',
				)}
				lackOfPermission={lackOfPermission}
			>
				<VerticalBarAverageChart
					subDesc={t(
						'features.report.section-content.tt.engagement-tt.average-views.vertical-bar-average-chart.sub-description',
					)}
					valueUnit={t(
						'features.report.section-content.tt.engagement-tt.average-views.vertical-bar-average-chart.value-unit',
					)}
					label={t(
						'features.report.section-content.tt.engagement-tt.average-views.vertical-bar-average-chart.label',
					)}
					desc={true}
					{...averageViews}
					{...status}
				/>
			</ReportCard>
			<ReportCard
				label={t('features.report.section-content.tt.engagement-tt.average-likes.label')}
				tooltip={t(
					'features.report.section-content.tt.engagement-tt.average-likes.tooltip',
				)}
				lackOfPermission={lackOfPermission}
			>
				<VerticalBarAverageChart
					subDesc={t(
						'features.report.section-content.tt.engagement-tt.average-likes.vertical-bar-average-chart.sub-description',
					)}
					valueUnit={t(
						'features.report.section-content.tt.engagement-tt.average-likes.vertical-bar-average-chart.value-unit',
					)}
					label={t(
						'features.report.section-content.tt.engagement-tt.average-likes.vertical-bar-average-chart.label',
					)}
					desc={true}
					{...averageLikes}
					{...status}
				/>
			</ReportCard>
			<ReportCard
				label={t(
					'features.report.section-content.tt.engagement-tt.average-comments.label',
				)}
				tooltip={t(
					'features.report.section-content.tt.engagement-tt.average-comments.tooltip',
				)}
				lackOfPermission={lackOfPermission}
			>
				<VerticalBarAverageChart
					subDesc={t(
						'features.report.section-content.tt.engagement-tt.average-comments.vertical-bar-average-chart.sub-description',
					)}
					valueUnit={t(
						'features.report.section-content.tt.engagement-tt.average-comments.vertical-bar-average-chart.value-unit',
					)}
					label={t(
						'features.report.section-content.tt.engagement-tt.average-comments.vertical-bar-average-chart.label',
					)}
					desc={true}
					{...averageComments}
					{...status}
				/>
			</ReportCard>
			<ReportCard
				label={t('features.report.section-content.tt.engagement-tt.average-shares.label')}
				tooltip={t(
					'features.report.section-content.tt.engagement-tt.average-shares.tooltip',
				)}
				lackOfPermission={lackOfPermission}
			>
				<VerticalBarAverageChart
					subDesc={t(
						'features.report.section-content.tt.engagement-tt.average-shares.vertical-bar-average-chart.sub-description',
					)}
					valueUnit={t(
						'features.report.section-content.tt.engagement-tt.average-shares.vertical-bar-average-chart.value-unit',
					)}
					label={t(
						'features.report.section-content.tt.engagement-tt.average-shares.vertical-bar-average-chart.label',
					)}
					desc={true}
					{...averageShares}
					{...status}
				/>
			</ReportCard>
			<ReportCard
				label={t('features.report.section-content.tt.engagement-tt.average-saves.label')}
				tooltip={t(
					'features.report.section-content.tt.engagement-tt.average-saves.tooltip',
				)}
				lackOfPermission={lackOfPermission}
			>
				<VerticalBarAverageChart
					subDesc={t(
						'features.report.section-content.tt.engagement-tt.average-saves.vertical-bar-average-chart.sub-description',
					)}
					valueUnit={t(
						'features.report.section-content.tt.engagement-tt.average-saves.vertical-bar-average-chart.value-unit',
					)}
					label={t(
						'features.report.section-content.tt.engagement-tt.average-saves.vertical-bar-average-chart.label',
					)}
					desc={true}
					{...averageSaves}
					{...status}
				/>
			</ReportCard>
			<ReportCard
				label={t(
					'features.report.section-content.tt.engagement-tt.engagement-rate.label',
				)}
				tooltip={t(
					'features.report.section-content.tt.engagement-tt.engagement-rate.tooltip',
				)}
				lackOfPermission={lackOfPermission}
			>
				<BoldVerticalBarChart
					desc={true}
					data={[{ isMain: true }, {}]}
					{...status}
					{...engagementRate}
				/>
			</ReportCard>
		</div>
	);
};

export default EngagementTt;
